<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="标题">
                <el-input v-model="formInline.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="摘要">
                <el-input v-model="formInline.digest" placeholder="摘要"></el-input>
            </el-form-item>

        <el-form-item label="平台">
            <el-select v-model="formInline.platformId"  placeholder="平台" >
                <el-option v-for="item in platformData"
                           :key="item.platformId"
                           :label="item.platformName"
                           :value="item.platformId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" @click="handleAdd">新增</el-button>
            <el-button type="success" @click="handleGetMedia">获取公众号素材</el-button>
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformGroupName" label="公司"  width="100"></el-table-column>
                <el-table-column prop="platformName" label="平台" width="100"></el-table-column>
                <el-table-column prop="mediaId"  label="MediaId"></el-table-column>
                <el-table-column prop="author"  label="作者"  width="70"></el-table-column>
            <el-table-column prop="title"  label="标题" sortable></el-table-column>
            <el-table-column prop="digest"  label="摘要" sortable ></el-table-column>
            <el-table-column prop="url"  label="链接地址" sortable  width="80">
                <template slot-scope="scope">
                    <a :href="scope.row.url" target="_blank">链接</a>
                </template>
            </el-table-column>
            <el-table-column prop="imageUrl"  label="图片地址" sortable  width="80">
                <template slot-scope="scope">
                    <img :src="scope.row.imageUrl" width="70" height="70"/>
                </template>
            </el-table-column>
            <el-table-column prop="status"  label="状态" :formatter="statusShow" sortable  width="70"></el-table-column>
            <el-table-column prop="publish"  label="发布状态" :formatter="statusShow" sortable  width="70">
              <template slot-scope="scope">
                <el-tag v-if="scope.publish==1" type="success">已发布</el-tag>
                <el-tag v-if="scope.publish==0" type="success">草稿</el-tag>
              </template>
            </el-table-column>


                <el-table-column prop="updateTime" label="更新日期" sortable  width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="warning"  size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作者">
                    <el-input v-model=form.author clearable  placeholder="作者"></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model=form.title clearable  placeholder="标题"></el-input>
                </el-form-item>
                <el-form-item label="摘要" >
                    <el-input type="textarea"
                              :rows="5" v-model=form.digest clearable  placeholder="摘要"></el-input>
                </el-form-item>
                <el-form-item label="URL" >
                    <el-input v-model=form.url clearable  placeholder="URL"></el-input>
                </el-form-item>
                <el-form-item label="类型" >
                    <el-select v-model="form.type"  placeholder="类型"  @change="mediaTypeDataChange">
                        <el-option v-for="item in mediaTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="显示类型" >
                    <el-select v-model="form.showType"  placeholder="显示类型" @change="handleChange">
                        <el-option v-for="item in showTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="绑定码" >
                    <el-select v-model="form.bindCode"  placeholder="绑定码">
                        <el-option v-for="item in bindCodeData"
                                   :key="item.bindCode"
                                   :label="item.name"
                                   :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.status"  placeholder="状态">
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="第三方报道URL">
                    <el-input v-model=form.thirdUrl ></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <uploadComponents :fromState="'onlyOne'" v-model="form.imageUrl" :urlType="2" @selectPicOne="selectPicOne"></uploadComponents>
                    <!--<uploadComponents :fromState="'onlyOne'" v-model="form.navIcon" :urlType="2" @selectPicOne="selectPicOne"></uploadComponents>-->
                </el-form-item>
                <el-form-item label="正文" >
                    <el-input type="textarea" :rows="25" v-model=form.content clearable  placeholder="正文"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getMediaList,deleteMedia,saveMedia,getMedia,pullMediaList,getBindCodeList} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                mediaTypeData:[{"id":"news","name":"图文"},{"id":"image","name":"图片"}],
                showTypeData:[{"id":0,"name":"默认"},{"id":1,"name":"乐纯食堂"},{"id":2,"name":"乐纯口碑"},
                        {"id":3,"name":"乐纯故事"},{"id":4,"name":"微博"},{"id":5,"name":"商品评论"}],
                statusData:[{"id":0,"name":"禁用"},{"id":1,"name":"可用"}],
                bindCodeData:[],
                loading:true,
                dialogFormVisible:false,
                form:{"id":0,"platformId":1,"author":"","type":"news","title":"","digest":"","showType":0,"bindCode":"","content":"",
                    "mediaId":"","url":"","imageUrl":"","status":1,"thirdUrl":""},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled:false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                getMediaList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.weiXinMediaList.total;
                    this.listData = res.data.weiXinMediaList.list;
                    this.platformData=res.data.platFormList;
                })
            },
            getBindCodeDataList(){
                getBindCodeList({showType:5}).then((res) => {
                    console.log(res)
                    this.bindCodeData = res.data.value
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if(confirm("确定删除素材:"+row.title+"吗？")) {
                    deleteMedia({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form.id=0;
                this.form.imageUrl='';
                this.form.author='';
                this.form.digest='';
                this.form.title='';
                this.form.url='';
                this.form.type='';
                this.form.showType=0;
                this.form.status=1;
                this.form.thirdUrl='';
                this.form.content='';
                this.platformDisabled=false;
                //this.handleEdit(d);
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getMedia({id:data.id}).then((res) => {
                    if(res.data.data!=undefined) {
                        this.form = res.data.data;
                    }
                });
                this.getBindCodeDataList()
            },
            handleChange(data){
                this.form.showType=data;
            },
            mediaTypeDataChange(data){

            },
            save(data){
                console.log(data);
                if(data.title==""){
                    this.$message({
                        message:"请输入标题",
                        type:'error'
                    });
                    return;
                }
                if(data.type==""){
                    this.$message({
                        message:"请选择类型",
                        type:'error'
                    });
                    return;
                }
                if(data.showType===""){
                    this.$message({
                        message:"请选择显示类型",
                        type:'error'
                    });
                    return;
                }
                if(data.status==""){
                    this.$message({
                        message:"请选择状态",
                        type:'error'
                    });
                    return;
                }

                saveMedia(data).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },

            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
            },
            selectPicOne(obj){
                console.log(obj)
                this.form.imageUrl=obj.allImagePath
            },
            handleGetMedia(){
                var  platformId=this.formInline.platformId;
                if(platformId==undefined){
                    this.$message({
                        message:"请选择平台",
                        type:'error'
                    });
                    return;
                }
                var platformName="";
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==platformId) {
                        platformName= this.platformData[key].platformName;
                        break;
                    }
                }
                if(platformName==''){
                    this.$message({
                        message:"请选择平台",
                        type:'error'
                    });
                    return;
                }
                if(confirm("确定拉取["+platformName+"]的素材吗？")){
                    pullMediaList({"platformId":platformId}).then((res) => {
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible=false;
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    });
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatmediaList.vue